import { render, staticRenderFns } from "./editVip.vue?vue&type=template&id=fbf4fa7a&lang=pug"
import script from "./editVip.vue?vue&type=script&lang=js"
export * from "./editVip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports